export type MatchSpec =
  | { type: 'string'; name: string }
  | { type: 'map'; names: Record<string, unknown> }
  | { type: 'regexp'; regexp: RegExp }

export const matchName = (match: MatchSpec, name: string): boolean => {
  switch (match.type) {
    case 'string':
      return match.name === name

    case 'map':
      // Non-null assertion intentional: MatchSpec discriminated union guarantees
      // names is defined when type is 'map'. Missing field should throw (master
      // behavior) rather than silently skip.
      return !!match.names[name]

    case 'regexp':
      return match.regexp.test(name)
  }

  return false
}
